/**
 * Turning the server's 422 into something the feedback dialog can point at.
 *
 * The walk moved to `lib\validation-errors.ts` on 2026-08-05. This file had the
 * only copy of the prefix strip, which is what made the drift visible: the same
 * refusal read as a sentence here and as a sentence with pydantic's error class
 * bolted to its front on the provider and OFO forms. The strip now lives in the
 * shared module and every form inherits it.
 *
 * This dialog stays narrower than the map-building callers because it has one
 * field worth blaming.
 */

import { messageFrom } from "@/lib/validation-errors"

export { fieldErrorFrom } from "@/lib/validation-errors"

/**
 * The sentence for the banner above the dialog.
 *
 * Deliberately the plain {@link messageFrom} and not the shared
 * `formErrorFrom`, which says "check the highlighted fields". This dialog only
 * highlights `description`, so a refusal naming any other field lands here with
 * nothing highlighted on screen, and pointing at fields that are not marked
 * would send somebody hunting for a mark that was never drawn.
 */
export function formErrorFrom(cause: unknown, fallback: string): string {
  return messageFrom(cause, fallback)
}
